export default __webpack_public_path__ + "static/media/Favorite.2d427512.jpg";